"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TODO = exports.EMAIL = exports.CALL = void 0;
var CALL = 'CALL';
exports.CALL = CALL;
var EMAIL = 'EMAIL';
exports.EMAIL = EMAIL;
var TODO = 'TODO';
exports.TODO = TODO;